"use strict";

const KTLayoutHeader = require('../base/header');
const KTLayoutSubheader = require('../base/subheader');
const CardCategory = require('./card-category');
const EventListener = require('./event-listener');
const { getTreeviewSubSectionItems, getTreeviewSubSectionItemById, getQuickAccessItems } = require('./helpers');
const QFavoriteButton = require('./q-favorite-button');
const { effect, computed } = require('@node_modules/@preact/signals-core');

class QDashboardMenu {
    constructor(elementId, config) {
        this._element = $(`#${elementId}`);

        if (!this._element) return {};

        /** @type {{sections: import("./q-menu").Section[]}} */
        this._menuConfig = config.menuConfig;
        this._templates = config.template;
        this._lazy = config.lazyLoad;
        this._categoryActiveKey = config.saveCategoryActive;
        this._effectsQuickAccess = [];


        this._initEventListeners();
        this._build();
    }

    _build() {
        this._includeQuickAccesSectionConfig();

        if (this._lazy) {
            this._cardMenuListEl = $(/*html*/`<div class="tab-content menus-card">`);

            const mainEl = this._buildSections();

            this._element.append(mainEl, this._cardMenuListEl);
        }
        else {
            const mainEl = this._buildSections();

            const menusLevelEL = this._buildMenusCard();
            
            this._element.append(mainEl, menusLevelEL);
        }
    }

    _includeQuickAccesSectionConfig() {
        const sections = [];

        this._menuConfig.sections.forEach((section) => {
            sections.push(section);

            if (section.isCompany) {
                sections.push(this._createQuickAccessSection());
            }
        });

        this._menuConfig.sections = sections;
    }
    
     _createQuickAccessSection() {
        const section = this._menuConfig.sections;
        const favoriteItems = computed(() => {
            return getQuickAccessItems(
                section, 
                (item) => item._isFavorite.value
            );
        });
        const recentItems = computed(() => {
            return getQuickAccessItems(
                section,
                (item) => item._isRecent.value,
                (a, b) => ((a.recentOrder || 0) - (b.recentOrder || 0))
            );
        });
        
        return {
            caption: 'Acesso Rápido',
            isQuickAccess: true,
            icon: 'bg-icon-quick-access', 
            _uuid: uuidv4().replace(/-/g, '_'),
            items: [
                {
                    caption: 'Recentes',
                    _uuid: uuidv4().replace(/-/g, '_'),
                    toolButtons: [{ type: 'show-less-button' }],
                    items: recentItems,
                },
                {
                    caption: 'Favoritos',
                    _uuid: uuidv4().replace(/-/g, '_'),
                    toolButtons: [{ type: 'show-less-button' }],
                    items: favoriteItems,
                }
            ]
        }
    }

    _buildSections() {
        const card = $(/*html*/`
            <div class="card card-custom gutter-b">
                <div class="card-body p-0">
                <ul class="nav nav-pills row row-paddingless m-0 p-0 flex-column flex-sm-row"></ul>
                </div>
            </div>
        `);

        const sections = this._menuConfig.sections
            .filter(({ isProduct }) => !isProduct)
            .map((section) => this._buildSection(section));

        card.find('ul')
            .append(sections);

        this._setActiveCompanyContent();
        this._setSectionClickEvent(card);

        return card;
    }

    _setActiveCompanyContent() {
        const companySection = this._menuConfig.sections.find((section) => section.isCompany);
        
        this._toggleCompanyContentItems(Boolean((companySection || {}).isActive));
    }

    _setSectionClickEvent(card) {
        const resetDropdown = (/** @type {HTMLLIElement} */ li) => {
            $(li)
                .find('.dropdown-menu a')
                .each((index, element) => {
                    $('input:checked', element).prop('checked', false).trigger('change');
                    $(element.hash).toggleClass('active', false);
                });

            $(li).find('> a').toggleClass('active', false);
        };

        const resetPreviousSelection = (card, currentLi, isCompany, isSubsection) => {
            this._toggleCompanyContentItems(false);

            if (isSubsection || isCompany) {
                card
                    .find('ul li.nav-item')
                    .each((index, liElement) => {
                        const sectionLink = $(liElement).find('> a');

                        if (liElement == currentLi) { // activate current Item
                            sectionLink.toggleClass('active', true);
                        }
                        else if ($(liElement).hasClass('dropdown')) { // deactivate dropdown items
                            sectionLink.toggleClass('active', false);

                            resetDropdown(liElement);
                        }
                        else { // deactivate normal item
                            sectionLink.toggleClass('active', false);

                            if (this._lazy) {
                                $(sectionLink.prop('hash')).remove();
                            }
                            else {
                                $(sectionLink.prop('hash')).toggleClass('active', false);
                            }
                        }
                    });
            }
            else {
                card
                    .find('ul li.nav-item')
                    .each((index, li) => {
                        resetDropdown(li);
                    });
            }
        };

        card.on('hide.bs.dropdown', '.dropdown', (event) => {
            const currentTarget = $(event.currentTarget);

            if (!currentTarget.find('input:checked').length) {
                $(event.relatedTarget).toggleClass('active', false);
            }
        })

        card
            .on('click', '.nav-item a:not([data-toggle="dropdown"])', (event) => {
                const currentTarget = $(event.currentTarget);
                const isSubsection = currentTarget.hasClass('dropdown-item');
                const isCompany = currentTarget.data('dashboard-company');
                const currentLi = currentTarget.closest('li').get(0);

                resetPreviousSelection(card, currentLi, isCompany, isSubsection);
                
                if (isSubsection) {
                    event.stopPropagation();
                }
                else {
                    event.preventDefault();
                    
                    if (isCompany) {
                        this._toggleCompanyContentItems(true);
                        
                        $('> a' , currentLi).toggleClass('active', true);
                    }
                    else {
                        if (this._lazy) {
                            const uuid = currentTarget.attr('href').replace('#tab_', '');
                            const sectionConfig = this._menuConfig.sections.find(({ _uuid }) => uuid == _uuid);
                            
                            this._cardMenuListEl.children().remove()

                            if (!this._element.find(`[id="tab_${uuid}"]`).length) {
                                this._cardMenuListEl.append(this._menusCardTemplate({ ...sectionConfig, isActive: true }));
                            }
                        }

                        currentTarget.tab('show');
                    }
                }
            })
            .on('change', '.nav-item a:not([data-toggle="dropdown"]) input[type="checkbox"]:not(.checkbox-check-all)', (event) => {
                const currentTarget = $(event.currentTarget).closest('a');
                const isCompany = currentTarget.data('dashboard-company');
                const isSubsection = currentTarget.hasClass('dropdown-item');
                const currentLi = currentTarget.closest('li').get(0);

                resetPreviousSelection(card, currentLi, isCompany, isSubsection);

                if (isSubsection) {
                    const id = currentTarget.get(0).hash;
                    const checked = ($(event.currentTarget).prop('checked'));

                    $(id).toggleClass('active', checked);
                }
            });
    }

    _toggleCompanyContentItems(isActive) {
        $('[data-dashboard-company-content="true"]', $('#q_dashboard_menu').parent()).toggleClass('d-none', !isActive);
    };

    _buildSection(section) {
        const subSections = section.items.filter((subSectionOrMenu) => subSectionOrMenu.items);

        if (subSections.length && !section.isQuickAccess) {
            const hasActiveSubsection = Boolean(subSections.find((subsection) => subsection.isActive));
            const every = subSections.every((subSection) => subSection.isActive);
            const some = subSections.some((subSection) => subSection.isActive);
            const subsectionWithTitle = subSections.filter((subSection) => subSection.title);
            let checkboxList;

            const subsectionItem = $(/*html*/`
                <li class="nav-item dropdown   d-flex col-sm flex-grow-1 flex-shrink-0 mr-0 mb-3 mb-lg-0">
                    <a 
                        class="nav-link ${hasActiveSubsection ? 'active' : ''} btn btn-clean btn-text rounded-0 border-right nav-link py-0 my-6 d-flex flex-grow-1 flex-column align-items-center "
                        data-toggle="dropdown"
                        href="#"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span class="nav-icon py-2 w-auto">
                            <i class="la ${section.icon || 'la-home'} icon-3x"></i>
                        </span>
                        <span class="nav-text h1 py-2 text-center btn dropdown-toggle">${section.caption}</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right border border-primary">
                        <div class="checkbox-list custom-scrollbar"></div>
                                    
                    </div>
                </li>
            `);

            const checkboxAll = $(/*html*/`
                <a class="dropdown-item p-0">
                    <label class="checkbox checkbox-outline m-0 py-3 px-6 d-inline-flex">
                        <input type="checkbox" class="checkbox-check-all">
                        <span></span>
                        Todos
                    </label>
                </a>
            `);

            const dropdownHeader = $(`
                <div class="justify-content-between d-flex">
                    <div class="checkbox-list">
                        
                    </div>
                    <div class="d-flex align-content-center flex-wrap px-6">
                        <span class="btn btn-link-primary font-weight-bolder show-less-items">
                            Fechar
                            <i class="las la-times"></i>
                        </span>
                    </div>
                </div>`
            );

            dropdownHeader.find('.checkbox-list').append(checkboxAll);

            const buildSubsections = (subSections) => {
                return subSections.map((subSection) => {
                    return $(/*html*/`
                        ${subSection.title
                            ? /*html*/`<div class="h1 text-primary dropdown-item m-0">${subSection.title}</div>`
                            : ''
                        }
                        <a class="dropdown-item p-1" href="#tab_${subSection._uuid}">
                            <label class="checkbox checkbox-outline m-0 py-0 px-5 d-inline-flex">
                                <input type="checkbox"${subSection.isActive? ' checked' : ''}>
                                <span class="mr-2"></span>
                                ${subSection.caption}
                                <u class="text-primary pl-5 checkbox-check-only">Somente</u>
                            </label>
                        </a>
                    `);
                });
            };

            if (subsectionWithTitle.length) {
                const titlePositions = subSections
                    .map((subSection, index) => subSection.title ? index : -1)
                    .filter((index) => index != -1);

                const subSectionsGroup = titlePositions.map((position, index) => {

                    return subSections.slice(position, titlePositions[index + 1])
                });

                checkboxList = subSectionsGroup.map((item => $('<div>').append(buildSubsections(item))));
            }
            else {
                checkboxList = buildSubsections(subSections)
            }


            checkboxAll
                .find('input')
                .prop({
                    checked: every,
                    indeterminate: !every && every !== some,
                });

            const checkboxListEl = subsectionItem.find('.dropdown-menu .checkbox-list');

            checkboxListEl.append(checkboxList);

            subsectionItem
                .find('.dropdown-menu')
                .prepend(dropdownHeader);

            subsectionItem
                .find('[data-toggle="dropdown"]')
                .data('popperConfig', {
                    positionFixed: true,
                    modifiers: {
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'viewport',
                        },
                        flip: {
                            enabled: false,
                        },
                        offset: {
                            enabled: true,
                            fn: (data) => {
                                const headerSize = KTLayoutHeader.getHeight() + KTLayoutSubheader.getHeight();
                                const offsets = data.offsets
                                const offsetTop = Math.ceil(offsets.reference.top + offsets.reference.height);
                                const top = offsetTop < headerSize ? headerSize : offsetTop;

                                if (subsectionWithTitle.length) {
                                    data.styles = {
                                        ...data.styles,
                                        transform: `translate3d(-50%, ${top}px, 0px)`,
                                        left: '50%',
                                        overflowY: 'hidden',
                                    };
                                }
                                else {
                                    data.styles = {
                                        ...data.styles,
                                        transform: `translate3d(${offsets.popper.left}px, ${top}px, 0px)`,
                                        overflowY: 'hidden',
                                    };
                                }

                                checkboxListEl.css({
                                    'max-height': `calc(100vh - ${top}px - ${dropdownHeader.height()}px - 4rem)`
                                });

                                return data;
                            }
                        }
                    },
                });

            checkboxListEl.css({
                'overflow-y': 'scroll',
            });

            if (subsectionWithTitle.length) {
                checkboxListEl.css({
                    display: 'grid',
                    'grid-template-columns': `repeat(${subsectionWithTitle.length > 2 ? 2 : 1}, minmax(auto, 1fr))`,
                });
            }

            const inputCheckboxList = subsectionItem.find('input[type="checkbox"]:not(.checkbox-check-all)');
            
            if (this._lazy) {
                const activeSection = subSections.find(({ isActive }) => isActive);
                
                if (activeSection) {
                    this._cardMenuListEl.append(this._menusCardTemplate(activeSection, subSections.indexOf(activeSection), section));
                }
            }

            subsectionItem
                .on('click', '.checkbox-check-only', (event) => { // item "somente"
                    event.preventDefault();
                    event.stopPropagation();
                                    
                    subsectionItem
                        .find('input[type="checkbox"]:not(.checkbox-check-all)')
                        .each((index, el) => $(el).prop('checked', false).trigger('change'));

                    $(event.target)
                        .closest('a.dropdown-item')
                        .find('input[type="checkbox"]')
                        .prop('checked', true)
                        .trigger('change');
                    
                    subsectionItem
                        .find('[data-toggle="dropdown"]')
                        .dropdown('hide');
                })
                .on('change', 'input[type="checkbox"].checkbox-check-all', (event) => { // item "todos"
                    const checked = $(event.target).prop('checked');
                    const indeterminate = $(event.target).prop('indeterminate');

                    inputCheckboxList.each((index, el) => $(el).prop('checked', checked && !indeterminate).trigger('change'));
                })
                .on('change', 'input[type="checkbox"]:not(.checkbox-check-all)', (event) => { // item das subsecoes
                    const checkStatus = inputCheckboxList.toArray().map((checkbox) => checkbox.checked);
                    const every = checkStatus.every(Boolean);
                    const some = checkStatus.some(Boolean);
                    const linkEl = $(event.target);

                    linkEl.closest('a.dropdown-item').toggleClass('active', linkEl.prop('checked'));

                    if (this._lazy) {
                        const uuid = linkEl.closest('a.dropdown-item').attr('href').replace('#tab_', '');
                        
                        if (linkEl.prop('checked')) {
                            if (!this._cardMenuListEl.find(`[id="tab_${uuid}"]`).length) {
                                const subSection = subSections.find(({ _uuid }) => _uuid == uuid);
                                const newEl = this._menusCardTemplate({ ...subSection, isActive: true }, subSections.indexOf(subSection));
                                
                                this._cardMenuListEl.prepend(newEl);
                            }
                        }
                        else {
                            this._cardMenuListEl.find(`[id="tab_${uuid}"]`).remove();
                        }
                    }


                    checkboxAll
                        .find('input')
                        .prop({
                            checked: every,
                            indeterminate: !every && every !== some,
                        });
                });

            return subsectionItem;
        }
        else {
            const sectionTemplate = (this._templates || {}).sectionTemplate;

            if (this._lazy && section.isActive && !section.isCompany) {
                this._cardMenuListEl.append(this._menusCardTemplate(section, 0));
            }

            if (sectionTemplate) return sectionTemplate(section);

            return this._sectionTemplate(section);
        }
    }

    _sectionTemplate(section) {
        const li = $(/*html*/`<li class="nav-item d-flex col-sm flex-grow-1 flex-shrink-0 mr-0 mb-3 mb-lg-0">`);
        const button = $(/*html*/`
            <a href="#tab_${section._uuid}" ${section.isCompany ? 'data-dashboard-company="true"' : ''} class="btn btn-clean btn-text rounded-0 border-right nav-link py-0 my-6 d-flex flex-grow-1 flex-column align-items-center ${section.isActive ? 'active' : ''}">
                <span class="nav-icon py-2 w-auto">
                    <i class="las ${section.icon || 'la-home'} icon-3x"></i>
                </span>
                <span class="nav-text h1 py-2  text-center">${section.caption}</span>
            </a>
        `);

        return li.append(button);
    }

    _buildMenusCard() {
        const divTab = $(/*html*/`<div class="tab-content">`);
        const cardList = this._menuConfig.sections.map((section) => {
            const subSections = section.items.filter((subSectionOrMenu) => subSectionOrMenu.items);

            if (subSections.length && !section.isQuickAccess) return subSections.map((subSection, index) => this._menusCardTemplate(subSection, index, section));
            
            if (section.isCompany) return [];

            return [this._menusCardTemplate(section)];
        });

        cardList.forEach((card) => divTab.append(card));

        return divTab;
    }

    _menusCardTemplate(subSection, index = 0, section = {}) {
        if (subSection.isQuickAccess) {
            return this._createQuickAccessCard(subSection, index);
        }

        const hasCategory = Boolean(!subSection.withTreeview && subSection.items.find((item) => item.items));

        if (!subSection.withTreeview && hasCategory) {
            return this._createCategoryMenuCard(subSection, index);
        }

        const tab = $(/*html*/`
            <div id="tab_${subSection._uuid}" data-index="${index}" class="tab-pane ${subSection.isActive ? 'active' : ''}">
                <div class="card card-custom change-view gutter-b">
                    <div class="card-header">
                        <div class="card-title">
                            <h3 class="card-label">${subSection.caption}</h3>
                        </div>
                        <div class="card-toolbar">
                            <a href="#" class="btn btn-link-primary font-weight-bolder show-less-items">
                                Ver menos
                                <i class="las la-times"></i>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <ul class="navi navi-hover"></ul>
                    </div>
                </div>
            </div>
        `);

        const items = this._buildItems(subSection.withTreeview ? getTreeviewSubSectionItems(subSection.items) : subSection.items, null, tab.find('.card-body ul.navi'));

        tab
            .find('.card-body ul.navi')
            .append(items);

        tab.on('click', 'a.show-less-items', (event) => {
            event.preventDefault();

            tab
                .find('.card.change-view')
                .removeClass('list-view');
        });

        return tab;
    }

    _clearEffectsQuickAccess() {
        this._effectsQuickAccess.forEach((dispose) => dispose());
        this._effectsQuickAccess = [];
    }

    _createQuickAccessCard(subSection, index = 0) {
        this._clearEffectsQuickAccess();

        const tab = $(` <div id="tab_${subSection._uuid}" data-index="${index}" class="tab-pane ${subSection.isActive ? 'active' : ''}">`);
        const tabs = subSection.items.map((tab, index) => {
            const contentEl = $('<ul class="navi navi-hover"></ul>');//.append(itemsEl);

            this._effectsQuickAccess.push(effect(() => {
                const itemsEl = this._buildItems(tab.items.value, { useTooltip: true });
                                
                contentEl.empty().append(itemsEl);
            }));

            return {
                caption: tab.caption,
                uuid: tab._uuid,
                content: contentEl,
                isActive: Boolean(!index)
            }
        });

        const cardCategory = CardCategory({
            caption: subSection.caption,
            tabs: tabs
        });

        tab.append(cardCategory);

        this._quickAccessEl = tab;

        return tab;
    }

    _createCardToolButton(toolButtons = []) {
        return toolButtons.map((toolButton) => {
            if (toolButton.type == 'show-less-button') {
                return {
                    toolEl: $(`<a href="#" class="btn btn-link-primary font-weight-bolder show-less-items">
                Ver menos
                <i class="las la-times"></i>
            </a>`),
                    onClick: (card) => card.removeClass('list-view'),
                    onShow: toolButton.onShow,
                    onHide: toolButton.onHide,
                }
            }
        })
    }

    _buildItems(items, options, listEl) {
        const menuItems = (this._lazy && listEl ? items.slice(0, 18) : items).map((item) => this._buildItem(item, options));
        const showMoreButton = this._buildShowMoreButton();

        if (this._lazy && listEl) {
            const buildOnClick = () => {
                listEl.append(
                    items.slice(18).map((item) => this._buildItem(item, options))
                );

                showMoreButton.off('click', buildOnClick);
            }

            showMoreButton.on('click', buildOnClick);
        }

        menuItems.push(showMoreButton);

        return menuItems;
    }

    _buildItem(item, options) {
        const template = (this._templates || {}).itemTemplate;

        return template
            ? template(item, options)
            : this._itemTemplate(item, options);
    }

    _itemTemplate(item, options) {
        const itemEl = $(/*html*/ `
            <li class="navi-item">
                <a class="navi-link${item.isActive ? ' active' : ''}" href="${item.href}">
                    <span class="navi-icon">
                        <i class="las ${item.icon ? item.icon : 'la-folder-open icon-default'} text-primary"></i>
                    </span>
                    <span class="navi-text">${item.caption}</span>
                    <span class="navi-label"></span>
                </a>
            </li>
        `);

        itemEl
            .find('.navi-label')
            .append(QFavoriteButton({ 
                item: item,
                onClick: (event) => {
                    this._dispatchEvent({
                        type: 'favorite-click',
                        originalEvent: event,
                        item: item,
                        isFavorite: $(event.currentTarget).find('i').hasClass('la-star'), 
                    });
                },
            }));

        if ((options || {}).useTooltip) {
            itemEl
                .find('a.navi-link')
                .tooltip({
                    placement: 'bottom',
                    title: item.path,
                    container: itemEl
                })
                .on('mouseleave', (event) => {
                    const tooltip = $(event.currentTarget).data('bs.tooltip');

                    if (tooltip) tooltip.hide();
                });
        }

        return itemEl;
    }

    _buildShowMoreButton() {
        const item = this._itemTemplate({
            href: '',
            icon: 'la-ellipsis-h',
            caption: 'VER TODOS'
        });

        item.find('.navi-label').remove();
        item.find('.navi-text').addClass('text-primary');

        return item
            .addClass('show-more-items')
            .on('click', (event) => {
                event.preventDefault();

                item
                    .closest('.card')
                    .addClass('list-view');
            });
    }

    _createCategoryMenuCard(subSection, index) {
        const tab = $(/*html*/`<div id="tab_${subSection._uuid}" data-index="${index}" class="tab-pane ${subSection.isActive? 'active' : ''}">`);
        const categoriesActive = subSection.items.map((category, index) => this._isCategoryActive(category, Boolean(!index)));
        const hasSomeActiveCategory = categoriesActive.some((isActive) => isActive)
        const categories = subSection.items.map((category, index) => {
            const listEl =  $('<ul class="navi navi-hover"></ul>')
            const itemsEl = this._buildItems(category.items, null, listEl);
            const contentEl = listEl.append(itemsEl);

            return {
                caption: category.caption,
                uuid: category._uuid,
                content: contentEl,
                isActive: !index && !hasSomeActiveCategory ? true : categoriesActive[index],
                onShownBsTab: this._categoryActiveKey ? () => this._saveCategoryActivePath(category) : undefined
            }
        });

        const cardCategory = CardCategory({
            caption: subSection.caption,
            tabs: categories
        });

        return tab.append(cardCategory);
    }

    _isCategoryActive(category, isFirstCategory) {
        if (this._categoryActiveKey) {
            const savedCategoryPath = this._getCategoryActivePath();

            if (savedCategoryPath) {
                try {
                    const savedPath = JSON.parse(savedCategoryPath);
                    const categoryPath = this._getCategoryPath(category);

                    return savedPath[categoryPath.path] == categoryPath.categoryCaption
                } catch { }
            }
        }

        return isFirstCategory;
    }

    _getCategoryPath(category) {
        let item = category;
        let path = '';

        while (item._parent) {
            item = item._parent;
            path = `${item.caption}${path ? '__' : ''}${path}`;
        }

        return {
            path: path, 
            categoryCaption: category.caption
        }
    }

    _getCategoryActivePath() {
        return localStorage.getItem(this._categoryActiveKey) || '';
    }

    _saveCategoryActivePath(category) {
        const categoryPath =  this._getCategoryPath(category);
        const saved = (() => {
            try {
                return JSON.parse(this._getCategoryActivePath());
            }
            catch {
                return {};
            }
        })();

        saved[categoryPath.path] = categoryPath.categoryCaption;

        localStorage.setItem(this._categoryActiveKey, JSON.stringify(saved));
    }

    clearCategoryActivePath() {
        localStorage.removeItem(this._categoryActiveKey);
    }

    toggleQuickAccessFavoriteItem(uuid, isFavorite) {
        const getItem = (items, uuid) => {
            if (Array.isArray(items)) {
                return items
                    .map((item) => {
                        if (item.withTreeview) return getTreeviewSubSectionItemById(item.items, uuid);

                        return getItem(item.items || item, uuid);
                    })
                    .find(item => item);
            }

            return items._uuid === uuid ? items : null;
        };

        if (!this._quickAccessEl) return;

        const favoriteTabContent = this._quickAccessEl.find('.tab-pane').eq(1);
        const item = getItem(this._menuConfig.sections, uuid);
        const itemEl = $(`[data-id="favorite_button_${item._uuid}"]`, favoriteTabContent).closest('li.navi-item');

        if(itemEl.length) {
            const tooltip = itemEl.find('a.navi-link').data('bs.tooltip');

                if (tooltip) {
                    tooltip.dispose();
                }

            itemEl.remove();
        }

        if (isFavorite) {
            const newItem = this._buildItem({
                ...item,
                isFavorite,
            }, { useTooltip: true });

            $(newItem).insertBefore($('ul.navi .show-more-items', favoriteTabContent));
        }
    }

    _initEventListeners() {
        this._eventListener = {
            'favorite-click': new EventListener()
        }
    }

    _dispatchEvent(event) {
        if (this._eventListener[event.type]) {
            this._eventListener[event.type].dispatch(event);
        }
    }

    on(type, listener) {
        if (this._eventListener[type]) {
            this._eventListener[type].addEventListener(listener);
        }
    }

    off(type, listener) {
        if (this._eventListener[type]) {
            this._eventListener[type].removeEventListener(listener);
        }
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = QDashboardMenu;
}